import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import { WodForm } from '.';

type PreviewProps = {
    test: Test
}

export class WodRawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <WodForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}